'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosPrinter = function IoIosPrinter(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm9.8 35v-17.5h20v17.5h-20z m0 0v-17.5h20v17.5h-20z m-1.3-27.5v-2.5h22.5v2.5h-22.5z m25.1 1.3c1.4 0 2.4 1 2.4 2.4v12.3c0 1.3-1 2.7-2.4 2.7h-2.6v-9.9h-22.5v9.9h-2.4c-1.4 0-2.6-1.4-2.6-2.7v-12.3c0-1.4 1.2-2.4 2.6-2.4h27.5z' })
        )
    );
};

exports.default = IoIosPrinter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-printer.js
// module id = 2286
// module chunks = 0